/* eslint-disable */
import axios from 'axios'
import {move} from 'move-position'


// Módulo para obtener buses
const baseUrl = process.env.VUE_APP_BASE_API + '/excursion'

const state = {
  buses: [],
  excursionBuses: [],
  pickupBuses: [],
  returnBuses: [],
  hasBookings: [],
  busesPath: [],
  sentPlanningData: [],
}

const actions = {

  async addNewBus({
    commit, dispatch
  }, busData) {
    return axios
      .post(baseUrl + '/buses/', busData)
      .then((response) => {
        if ( this.getters.activeTab === 'Excursions')  
          dispatch("loadExcursionBuses")
        else if ( this.getters.activeTab === 'Pickups')
          dispatch("loadPickupBuses")
        else if ( this.getters.activeTab === 'Returns')
          dispatch("loadReturnBuses")
      })
      .catch( (error) => {
        console.log(error)
        throw new Error(error)
      })
  },

  loadBuses({
    commit
  }, busData) {
    //const bus_type = this.getters.activeTab === 'Excursions' ? 'Excursion' : 'Pickup'
    let bus_type = 'Excursion'
    if ( this.getters.activeTab === 'Pickups')
      bus_type = 'Pickup'
    else if ( this.getters.activeTab === 'Returns')
      bus_type = 'Return'
    axios
      .get(
        baseUrl + '/buses/' + 
        '?day=' + this.getters.filterDate + 
        '&activity_group=' + this.getters.filterGroup + 
        '&bus_type=' + bus_type
      )
      .then(r => r.data)
      .then(buses => {
        commit('SET_BUSES', buses)
      })
  },

  loadExcursionBuses({
    commit
  }, data) {
    if (data == undefined ) {
      data = {
        show_spinner: false
      }
    }
    if ( data.show_spinner )
      commit("ISLOADING", ["bus", true], {root: true,});
    axios
      .get(
        baseUrl + '/buses/' + 
        '?day=' + this.getters.filterDate + 
        '&activity_group=' + this.getters.filterGroup + 
        '&bus_type=' + 'Excursion')
      .then(r => r.data)
      .then(excursionBuses => {
        commit('SET_EXCURSION_BUSES', excursionBuses)
        if ( data.show_spinner )
          commit("ISLOADING", ["bus", false], {root: true,});
      })
  },

  loadPickupBuses({
    commit
  }, data) {
    console.log("loadPickupBuses I")
    if (data == undefined ) {
      data = {
        show_spinner: false
      }
    }
    if ( data.show_spinner )
      commit("ISLOADING", ["bus", true], {root: true,});
    axios
      .get(
        baseUrl + 
        '/buses/' + 
        '?day=' + this.getters.filterDate + 
        '&activity_group=' + this.getters.filterGroup + 
        '&bus_type=' + 'Pickup')
      .then(r => r.data)
      .then(pickupBuses => {
        console.log("loadPickupBuses II")
        commit('SET_PICKUP_BUSES', pickupBuses)
        if ( data.show_spinner )
          commit("ISLOADING", ["bus", false], {root: true,});
      })
  },

  loadReturnBuses({
    commit
  }, data) {
    console.log("loadReturnBuses I")
    if (data == undefined ) {
      data = {
        show_spinner: false
      }
    }
    if ( data.show_spinner )
      commit("ISLOADING", ["bus", true], {root: true,});
    axios
      .get(
        baseUrl + 
        '/buses/' + 
        '?day=' + this.getters.filterDate + 
        '&activity_group=' + this.getters.filterGroup + 
        '&bus_type=' + 'Return')
      .then(r => r.data)
      .then(returnBuses => {
        console.log("loadReturnBuses II")
        commit('SET_RETURN_BUSES', returnBuses)
        if ( data.show_spinner )
          commit("ISLOADING", ["bus", false], {root: true,});
      })
  },

  async updateBus({
      commit,
      dispatch,
    },
    payload) {
    return axios
      .patch(baseUrl + '/buses/' + payload.id + '/', payload.data)
      .then((response) => {
        commit('UPDATE_BUS', {
          busData: response.data
        })
        // refresh buses list
        if ( this.getters.activeTab == 'Excursions' ) {
          dispatch("loadExcursionBuses")
        } else if ( this.getters.activeTab == 'Pickups' ) {
          dispatch("loadPickupBuses")
        } else if ( this.getters.activeTab == 'Returns' ) {
          dispatch("loadReturnBuses")
        }
                
      })
  },

  // Copy Bus excursion to Pickup
  async openBus({
    commit,
    dispatch
  }, id) {
    commit("ISLOADING", ["booking", true], {root: true,});
    return axios
      .patch(`${baseUrl}/buses/${id}/open_bus/`)
      .then(response => {
       
        if ( this.getters.activeTab === 'Excursions') {
          
          return Promise.all(
            [
              dispatch("bookings/loadBookingsByExcursionBus", {}, { root: true }),
              dispatch("bookings/loadBookingsByActivity", {}, { root: true }),
              dispatch("buses/loadExcursionBuses", {}, { root: true }),
              dispatch("buses/busesPath", {}, {root:true})
            ]
          ).finally( () => {
            console.log("\t\topenBus excursion view finally")
            commit("ISLOADING", ["booking", false], {root: true,});
          })
          
        } else if ( this.getters.activeTab === 'Pickups') {
          
          return Promise.all(
            [
              dispatch("bookings/loadBookingsByExcursionBus", {}, { root: true }),
              dispatch("bookings/loadBookingsByPickupBus", {}, { root: true }),
              dispatch("buses/loadPickupBuses", {}, { root: true })
            ]
          ).finally( () => {
            console.log("\t\topenBus pickups view finally")
            commit("ISLOADING", ["booking", false], {root: true,});
          })
          
        } else if ( this.getters.activeTab === 'Returns') {
          return Promise.allSettled(
            [
              //dispatch("bookings/loadBookingsByExcursionBus", {}, { root: true }),
              //dispatch("bookings/loadBookingsByPickupBus", {}, { root: true }),
              dispatch("bookings/loadBookingsByReturnBus", {}, { root: true }),
              dispatch("bookings/loadBookingsByStop", {}, {root: true}),
              dispatch("buses/loadReturnBuses", {}, { root: true })
            ]
          ).finally( () => {
            console.log("\t\topenBus pickups view finally")
            commit("ISLOADING", ["booking", false], {root: true,});
          })
        }
    })
  },

  deleteBus({
    commit
  }, id) {
    axios
      .delete(baseUrl + '/buses/' + id + '/')
      .then(() => {
        commit('DELETE_BUS', id)
      })
  },

  resetBusesList({
    commit
  }) {
    commit('RESET_BUSES')
  },

  hasBookings({
    commit
  }, id) {
    axios
      .get(baseUrl + '/buses/' + id + '/has_bookings/')
      .then(r => r.data)
      .then(response => {
        commit('SET_HASBOOKINGS', response)
      })
  },

  editBusInfo: async function ({
      commit,
    },
    payload) {
    return axios
      .patch(baseUrl + '/bustypes/' + payload.id + '/', payload.data)
  },

  busesPath({
    commit, dispath
  }) {
    commit("ISLOADING", ["default", true], {
      root: true,
    });
    console.log('request buses path endpoint')
    //const bus_type = this.getters.activeTab === 'Excursions' ? 'Excursion' : 'Pickup'
    let bus_type = ''
    if ( this.getters.activeTab === 'Excursions')
      bus_type = 'Excursion'
    else if ( this.getters.activeTab === 'Pickups' ) 
      bus_type = 'Pickup'
    else if ( this.getters.activeTab === 'Returns' )
      bus_type = 'Return'

    axios
      .get(
        baseUrl + '/buses/buses_path/' + 
        '?day=' + this.getters.filterDate + 
        '&activity_group_id=' + this.getters.filterGroup + 
        '&bus_type=' + bus_type)
      .then(r => r.data)
      .then( response => {
        commit('SET_BUSES_PATH', response)
        commit("ISLOADING", ["default", false], {
          root: true,
        });
      })
  },

  sendPlanning({
    commit, dispatch
  }, payload) {
    const stringify = JSON.parse(JSON.stringify(payload))
    const data = {
      'day': this.getters.filterDate,
      'activity_group_id': this.getters.filterGroup,
      'send': stringify
    }
    console.log('send planning to backend', data)
    axios
      .post(baseUrl + '/buses/send_planning/', data)
      .then( (response) => {
        console.log(response)
      })
  },

  sentPlanningData({
    commit, dispatch
  }) {
    commit("ISLOADING", ["default", true], {
      root: true,
    });
    axios
      .get(
        baseUrl + '/buses/sent_planning_data/' +
        '?day=' + this.getters.filterDate +
        '&activity_group_id=' + this.getters.filterGroup +
        '&suprazone_id=' + this.getters.filterSuprazone)
      .then( (response) => {
        commit('SET_PLANNING_DATA', response.data)
        commit("ISLOADING", ["default", false], {
          root: true,
        });
      })
  },

  reorderBusPath({
    commit, dispatch
  }, payload) {
    console.log('reorderBusPath payload', payload)
    let bus = this.getters.busPath(payload.bus_id)[0]
    console.log('busPath', bus.path)
    console.log('oldIdx', payload.oldIdx)
    console.log('newIdx', payload.newIdx)
    console.log('item to move', bus.path[payload.oldIdx].bus_stop)
    const pickup_bus = this.getters.activeTab == 'Pickups' ? true : false
    const excursion_bus = this.getters.activeTab == 'Excursions' ? true : false
    const return_bus = this.getters.activeTab == 'Returns' ? true : false
    let orderOldIdx, orderNewIdx
    if (pickup_bus) {
      orderOldIdx = bus.path[payload.oldIdx].bus_stop.order
      orderNewIdx = bus.path[payload.newIdx].bus_stop.order
    } else if ( excursion_bus ) {
      orderOldIdx = bus.path[payload.oldIdx].bus_stop.order_1
      orderNewIdx = bus.path[payload.newIdx].bus_stop.order_1
    } else if ( return_bus ) {
      orderOldIdx = bus.path[payload.oldIdx].bus_stop.order_2
      orderNewIdx = bus.path[payload.newIdx].bus_stop.order_2
    }
 
    //orderOldIdx = pickup_bus ? bus.path[payload.oldIdx].bus_stop.order : bus.path[payload.oldIdx].bus_stop.order_1
    //orderNewIdx = pickup_bus ? bus.path[payload.newIdx].bus_stop.order : bus.path[payload.newIdx].bus_stop.order_1
    
    console.log('orders', orderOldIdx, orderNewIdx)
    console.log('diferencia', Math.abs(payload.oldIdx - payload.newIdx))
    if ( Math.abs(payload.oldIdx - payload.newIdx) == 1 ) {
      console.log('diferencia un')
      if ( pickup_bus) {
        bus.path[payload.newIdx].bus_stop.order = orderOldIdx
        bus.path[payload.oldIdx].bus_stop.order = orderNewIdx
      } else if ( excursion_bus ) {
        bus.path[payload.newIdx].bus_stop.order_1 = orderOldIdx
        bus.path[payload.oldIdx].bus_stop.order_1 = orderNewIdx
      } else if ( return_bus ) {
        bus.path[payload.newIdx].bus_stop.order_2 = orderOldIdx
        bus.path[payload.oldIdx].bus_stop.order_2 = orderNewIdx
      }
    } else if ( payload.newIdx == bus.path.length - 1 ) {
      console.log('mogut al darrera')
      if ( pickup_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order
        bus.path[payload.newIdx].bus_stop.order = orderPreviousIdx + 50
      } else if ( excursion_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order_1
        bus.path[payload.newIdx].bus_stop.order_1 = orderPreviousIdx + 50
      } else if ( return_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order_2
        bus.path[payload.newIdx].bus_stop.order_2 = orderPreviousIdx + 50
      }
      
    } else if ( payload.newIdx == 0 ) {
      console.log('mogut al davant')
      if ( pickup_bus ) {
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order
        let value = orderNextIdx - 20
        bus.path[payload.newIdx].bus_stop.order = value < 0 ? 0 : value
      } else if ( excursion_bus ) {
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order_1
        let value = orderNextIdx - 20
        bus.path[payload.newIdx].bus_stop.order_1 = value < 0 ? 0 : value
      } else if ( return_bus ) {
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order_2
        let value = orderNextIdx - 20
        bus.path[payload.newIdx].bus_stop.order_2= value < 0 ? 0 : value
      }
    } else {
      if ( pickup_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order
        bus.path[payload.newIdx].bus_stop.order = Math.round((orderNextIdx + orderPreviousIdx) / 2)
      } else if ( excursion_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order_1
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order_1
        bus.path[payload.newIdx].bus_stop.order_1 = Math.round((orderNextIdx + orderPreviousIdx) / 2)
      } else if ( return_bus ) {
        let orderPreviousIdx = bus.path[payload.newIdx-1].bus_stop.order_2
        let orderNextIdx = bus.path[payload.newIdx+1].bus_stop.order_2
        bus.path[payload.newIdx].bus_stop.order_2 = Math.round((orderNextIdx + orderPreviousIdx) / 2)
      }
    }
    
    let result = move(bus.path, payload.oldIdx, payload.newIdx, false)
    //let result = bus.path.splice(payload.newIdx, 0, bus.path[payload.oldIdx])
    console.log('result1', result)
    
    //result = result.splice(payload.newIdx-1, 0, bus.path[payload.oldIdx])
    //console.log('result2', result)
    //bus.path = result
    let data = {
      busId: payload.bus_id,
      updatedPath: result,
    }
    commit('SET_BUS_PATH', data )

    let path = []
    for ( let p in bus.path ) {
      let order;
      if ( pickup_bus ) 
        order = bus.path[p].bus_stop.order
      else if ( excursion_bus )
        order = bus.path[p].bus_stop.order_1
      else if ( return_bus )
        order = bus.path[p].bus_stop.order_2
      let obj = {
        'id': bus.path[p].bus_stop.id,
        'order': order,
      }
      path.push(obj)
    }
    let bus_type = 'Excursion'
    if ( pickup_bus )
      bus_type = 'Pickup'
    else if ( return_bus )
      bus_type = 'Return'

    data = {
      bus_id: payload.bus_id,
      update: path,
      bus_type: bus_type,
    }
    console.log('data to send backend', data)
    // send changes to backend
    axios
      .post(baseUrl + '/buses/reorder_bus_path/', data)
      .then((response) => {
          console.log(response)
          dispatch("busesPath")
        }
      )
  }

}

const mutations = {

  SET_BUSES(state, buses) {
    state.buses = buses
  },

  SET_EXCURSION_BUSES(state, excursionBuses) {
    state.excursionBuses = excursionBuses
  },

  SET_PICKUP_BUSES(state, pickupBuses) {
    state.pickupBuses = pickupBuses
  },

  SET_RETURN_BUSES(state, returnBuses) {
    state.returnBuses = returnBuses
  },

  SET_BUSES_PATH(state, busesPath) {
    state.busesPath = busesPath
  },

  SET_BUS_PATH(state, {busId, updatedPath}) {
    let bus = state.busesPath.filter(bus => bus.bus_id == busId)
    bus.path = updatedPath
  },

  SET_PLANNING_DATA(state, planning) {
    state.sentPlanningData = planning
  },

  ADD_BUS: (state, {
    bus
  }) => {
    state.excursionBuses.push(bus);
    state.pickupBuses.push(bus);
  },

  UPDATE_BUS: (state, {
    busData
  }) => {
    let idx = state.buses.map(p => p.id).indexOf(busData.id)
    state.excursionBuses.splice(idx, 1, busData)
    state.pickupBuses.splice(idx, 1, busData)
  },

  DELETE_BUS(state, id) {
    let idxExcursionBuses = state.excursionBuses.findIndex(bus => bus.id == id);
    state.excursionBuses.splice(idxExcursionBuses, 1);

    let idxPickBuses = state.pickupBuses.findIndex(bus => bus.id == id);
    state.pickupBuses.splice(idxPickBuses, 1);
  },

  RESET_BUSES(state) {
    state.buses = []
  },

  SET_HASBOOKINGS(state, response) {
    state.hasBookings = [response]
  },

  RESET_BUSES_PATH(state) {
    console.log('reset buses path')
    state.busesPath = []
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}